import React, { useState, useEffect, useRef } from "react";
import Pajination from "../../helpingFiles/Pagination/Pajination";
import SideBar from "../../Components/Navbar/Sidebar";
import instance from "../../Components/Apis/axios";
import Head from "../../Components/ontabletop/head";
import { AiFillEdit } from "react-icons/ai";
import { toast, ToastContainer } from "react-toastify";
import { Link, useLocation } from "react-router-dom";
import {
  allLeadsList,
  assignedList,
  changeLeadStatusApi,
  activityNotes,
  allActivityies,
  leadSources,
} from "../../Components/Apis/apis";
import { FaFileDownload } from "react-icons/fa";
import EditLead from "../../Components/Leads/EditLead";
import CreateLead from "../../Components/Leads/createLead";
import { allProposalsApi } from "../../Components/Apis/apis";
import "./style.css";
import Reminder from "../../Components/Leads/reminder";
import Loader from "../../Components/loader";

const additional = [
  "Lost",
  "Junk",
  "Public",
  "Contacted Today",
  "Created Today",
];

const WebLeads = () => {
  const locations = useLocation();
  const [loading, setLoading] = useState(false);
  const [lead, setLaeds] = useState(false);
  const [createlead, setCreatelead] = useState(false);
  const [model, setModel] = useState([]);
  const [leadstatus, setLeadStatus] = useState([]);
  const [updateLead, setUpdateLead] = useState(false);
  const [AssignLead, setAssignLead] = useState([]);
  const [allSources, setallSources] = useState([]);
  const path = locations.pathname;
  const [posts, setPosts] = useState([]);
  const [filterData, setFilterData] = useState([]);

  const [total, setTotal] = useState("");
  const [page, setPage] = useState(1);
  const [postPerpage, setPostPerPage] = useState(10);
  const [query, setQuery] = useState("");

  const fetchPost = async () => {
    setLoading(true);
    const data = await allLeadsList(path);
    if (data.message === "You are not authorized for this page") {
      alert(data.message);
    } else {
      setPosts(data);
      setFilterData(data);
      setTotal(data.length);
      setLoading(false);
      statusofLeads();
    }
  };

  const statusofLeads = async () => {
    const { data } = await instance.get(`weblead/leadStatus`);
    setLeadStatus(data);
    assignLeads();
  };

  const assignLeads = async () => {
    const data = await assignedList();
    setAssignLead(data);
  };

  const fetchSource = async () => {
    const data = await leadSources();
    setallSources(data);
  };

  useEffect(() => {
    fetchPost();
    fetchSource();
  }, []);

  const flterLeds = async (e) => {
    const allData = [...posts];
    if (e === "all") {
      setFilterData(allData);
    } else {
      const data = allData.filter(
        (el) =>
          el.media_path_slug === e || el.leadstatus === e || el.leadsource === e
      );
      setFilterData(data);
      setTotal(data.length)
    }
  };

  const changeStatus = async (status, id) => {
    const data = await changeLeadStatusApi(status, id, path);
    toast("Lead status changed");
   fetchPost();
  };

  const headers = [
    { key: "name", label: "Name" },
    { key: "company", label: "Company" },
    { key: "email", label: "Email" },
    { key: "phone", label: "Phone" },
    { key: "assigned", label: "Assigned" },
    { key: "source", label: "Source" },
    { key: "created", label: "Created" },
    { key: "status", label: "Status" },
    { key: "id", label: "Action" },
  ];

  // Get Current Posts (Pagination)
  const indexOfLastPage = page * postPerpage;
  const indexOfFirstPage = indexOfLastPage - postPerpage;
  const currentPosts = filterData.slice(indexOfFirstPage, indexOfLastPage);

  let leadSource;
  const sourceleads = allSources.map((illumation) => illumation.name);
  leadSource = [...new Set(sourceleads)];

  const ProfileButton = useRef(null);
  const ProposalsButton = useRef(null);
  const RemindersButton = useRef(null);
  const ActivityButton = useRef(null);

  const profileref = useRef(null);
  const proposalref = useRef(null);
  const reminderref = useRef(null);
  const activityref = useRef(null);

  const switchTab = (e, tab) => {
    if (tab === "Profile") {
      ProfileButton.current.classList.add("navActive");
      ProposalsButton.current.classList.remove("navActive");
      RemindersButton.current.classList.remove("navActive");
      ActivityButton.current.classList.remove("navActive");

      profileref.current.classList.remove("Hidden");
      proposalref.current.classList.add("Hidden");
      reminderref.current.classList.add("Hidden");
      activityref.current.classList.add("Hidden");
    }

    if (tab === "Proposals") {
      getAllProposel();
      ProfileButton.current.classList.remove("navActive");
      ProposalsButton.current.classList.add("navActive");
      RemindersButton.current.classList.remove("navActive");
      ActivityButton.current.classList.remove("navActive");

      profileref.current.classList.add("Hidden");
      proposalref.current.classList.remove("Hidden");
      reminderref.current.classList.add("Hidden");
      activityref.current.classList.add("Hidden");
    }
    if (tab === "Reminders") {
      ProfileButton.current.classList.remove("navActive");
      ProposalsButton.current.classList.remove("navActive");
      RemindersButton.current.classList.add("navActive");
      ActivityButton.current.classList.remove("navActive");

      profileref.current.classList.add("Hidden");
      proposalref.current.classList.add("Hidden");
      reminderref.current.classList.remove("Hidden");
      activityref.current.classList.add("Hidden");
    }
    if (tab === "Activity") {
      getAllActivityies();
      ProfileButton.current.classList.remove("navActive");
      ProposalsButton.current.classList.remove("navActive");
      RemindersButton.current.classList.remove("navActive");
      ActivityButton.current.classList.add("navActive");

      profileref.current.classList.add("Hidden");
      proposalref.current.classList.add("Hidden");
      reminderref.current.classList.add("Hidden");
      activityref.current.classList.remove("Hidden");
    }
  };

  const [proposals, setProposals] = useState([]);
  const getAllProposel = async () => {
    if (model) {
      const id = model.id;
      const data = await allProposalsApi(path, id);
      setProposals(data);
      setTotal(data.length);
    }
  };
  const [activity, setActivity] = useState([]);
  const [note, setNote] = useState("");

  const saveNotes = async () => {
    const data = await activityNotes(path, model.id, note);
    getAllActivityies();
  };
  const getAllActivityies = async () => {
    const data = await allActivityies(model.id);

    setActivity(data);
  };

  const formatDate = (dateTimeString) => {
    const options = { 
      day: "2-digit", 
      month: "2-digit", 
      year: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      // second: "2-digit",
      hour12: true,
      // timeZoneName: "short"
    };
    const formattedDateTime = new Date(dateTimeString).toLocaleString("en-US", options);
    return formattedDateTime;
  };
  return (
    <>
      <div className="containers">
        <div className="container-sidebar">
          <SideBar />
        </div>
        {lead ? (
          <div className="container-pages m-5 p-5 my-5 ">
            <div className="text-center ">
                  <span className="text-center display-6 ">Lead ID: {model.id}</span>
              <span
                className="edit-btn float-right mt-0 "
                onClick={(e) => setLaeds(false)}
              >
                Back
              </span>
            </div>

            <section className="page-container my-4 pe-0">
              <div className="page-container-navv ">
                <ul className="mb-0">
                  <li
                    onClick={(e) => switchTab(e, "Profile")}
                    ref={ProfileButton}
                    className="navActive ms-0"
                  >
                     Details
                  </li>
                  <li
                    className="d-none"
                    onClick={(e) => switchTab(e, "Proposals")}
                    ref={ProposalsButton}
                  >
                    {" "}
                    Proposal
                  </li>
                  <li
                  
                    onClick={(e) => switchTab(e, "Reminders")}
                    ref={RemindersButton}
                  >
                    {" "}
                    Reminder
                  </li>
                  <li
                    
                    onClick={(e) => switchTab(e, "Activity")}
                    className="me-0"
                    ref={ActivityButton}
                  >
                    {" "}
                    Activity Log
                  </li>
                </ul>
              </div>
            </section>

            <div ref={profileref}>
              <h6
                onClick={(e) => setUpdateLead(!updateLead)}
                className="  edit-btn-main"
              >
                {!updateLead ? (
                  <>
                    {" "}
                    Edit{" "}
                    <span>
                      <AiFillEdit className="ms-1" />
                    </span>{" "}
                  </>
                ) : (
                  <>Cancel</>
                )}
              </h6>

              <EditLead
                model={model}
                updateLead={updateLead}
                setLaeds={setLaeds}
                AssignLead={AssignLead}
                leadstatus={leadstatus}
                leadSource={leadSource}
                fetchPost={fetchPost}
              />
            </div>
            <div id="reminder" ref={reminderref} className="Hidden">
             <Reminder model={model} />
            </div>

            <div id="proposal" ref={proposalref} className="Hidden">
              <Link to={`/proposals_lead/lead/${model.id}`}>
                <button className="edit-btn border-0" disabled>
                  New Perposal
                </button>
              </Link>
              <Head setPostPerPage={setPostPerPage} setQuery={setQuery} />
              <table className="table table-boarder table-hover table-striped  table-sm">
                <thead className="thead-dark">
                  <tr>
                    {headers.map((row) => (
                      <th key={row.key} scope="col">
                        {row.label}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {proposals &&
                    proposals
                      .filter((obj) => {
                        if (query === "") {
                          return obj;
                        } else if (
                          obj.name
                            .toLowerCase()
                            .includes(query.toLowerCase()) ||
                          obj.phonenumber
                            .toString()
                            .toLowerCase()
                            .includes(query.toLowerCase()) ||
                          obj.media_path_slug
                            .toLowerCase()
                            .includes(query.toLowerCase()) ||
                          obj.leadstatus
                            .toLowerCase()
                            .includes(query.toLowerCase()) ||
                          obj.leadsource
                            .toLowerCase()
                            .includes(query.toLowerCase()) ||
                          obj.dateadded
                            .toString()
                            .toLowerCase()
                            .includes(query.toLowerCase())
                        ) {
                          return obj;
                        }
                      })
                      .map((posts, index) => (
                        <tr key={index}>
                          <td className=" pe-auto text-center text-primary ms-1">
                            {posts.rel_id}
                          </td>
                          <td>{posts.subject}</td>
                          <td>{posts.address}</td>
                          <td>{posts.total}</td>
                          <td>{posts.date}</td>

                          <td>{posts.open_till}</td>

                          <td>{posts.datecreated}</td>

                          <td>{posts.status}</td>
                          <td>
                            <FaFileDownload />
                          </td>
                        </tr>
                      ))}
                </tbody>
              </table>
              <Pajination
                setPostPerPage={setPostPerPage}
                postPerpage={postPerpage}
                page={page}
                setPage={setPage}
                total={total}
              />
            </div>

            <div id="activity" ref={activityref} className="Hidden">
              <div className="d-flex">
                <input
                  type="text"
                  onChange={(e) => setNote(e.target.value)}
                  className="form-control activity-input ms-0"
                />
                <button onClick={saveNotes} className="edit-btn  border-0 ">
                  Save
                </button>
              </div>

              <ol className="ps-3 mt-3">
                {activity.map((el) => (
                  <li key={el} className="my-2">
                    {el.full_name} : {el.description} at {formatDate(el.date)}
                  </li>
                ))}
              </ol>
            </div>
          </div>
        ) : (
          <>
            {createlead ? (
              <>
                <div className="container-pages m-5 p-5 my-5 ">
                  <CreateLead
                    setCreatelead={setCreatelead}
                    AssignLead={AssignLead}
                    leadstatus={leadstatus}
                    leadSource={leadSource}
                    fetchPost={fetchPost}
                  />
                </div>{" "}
              </>
            ) : (
              <>
                <div className="container-pages">
                  <div className="row ">
                    <div className="container-page-top">
                      <button onClick={() => setCreatelead(true)}>
                        New Lead
                      </button>
                    </div>
                    <div className="row mt-3">
                      <div className="col">
                        {" "}
                        <h4>Filter By</h4>
                      </div>
                      <div className="col me-5 pe-5">
                        <select
                          className="custom-select"
                          onChange={(e) => flterLeds(e.target.value)}
                        >
                          <option disabled={true} selected>
                            Assigned by
                          </option>
                          <option value={"all"}>All</option>

                          {AssignLead.map((el) => (
                            <option value={el.media_path_slug}>
                              {el.media_path_slug}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col">
                        {" "}
                        <select
                          className="custom-select"
                          onChange={(e) => flterLeds(e.target.value)}
                        >
                          <option disabled={true} selected>
                            Lead status
                          </option>
                          <option value={"all"}>All</option>
                          {leadstatus.map((el) => (
                            <option value={el.name}>{el.name}</option>
                          ))}
                        </select>
                      </div>
                      <div className="col">
                        {" "}
                        <select
                          className="custom-select"
                          onChange={(e) => flterLeds(e.target.value)}
                        >
                          <option disabled={true} selected>
                            Lead source
                          </option>
                          <option value={"all"}>All</option>
                          {leadSource.map((el) => (
                            <option value={el}>{el}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <Head setPostPerPage={setPostPerPage} setQuery={setQuery} />
                  {loading ? (
                    <Loader />
                  ) : (
                    <>
                      {currentPosts.length == 0 ? (
                        <h2 className="text-secondary">No Leads found</h2>
                      ) : (
                        <>
                          {/* making User tabel */}
                          <table className="table table-boarder table-hover table-striped table-sm">
                            <thead className="thead-dark">
                              <tr>
                                {headers.map((row) => {
                                  return <th key={row.key}>{row.label}</th>;
                                })}
                              </tr>
                            </thead>
                            <tbody>
                              {/* putting data on table by map function */}
                              {currentPosts
                                .filter((obj) => {
                                  if (query === "") {
                                    return obj;
                                  } else if (
                                    obj.name
                                      .toLowerCase()
                                      .includes(query.toLowerCase()) ||
                                    obj.company
                                      .toLowerCase()
                                      .includes(query.toLowerCase()) ||
                                    obj.email
                                      .toLowerCase()
                                      .includes(query.toLowerCase()) ||
                                    obj.phonenumber
                                      .toLowerCase()
                                      .includes(query.toLowerCase()) ||
                                    obj.id
                                      .toString()
                                      .toLowerCase()
                                      .includes(query.toLowerCase())
                                  ) {
                                    return obj;
                                  }
                                })
                                .map((posts, index) => (
                                  <tr key={index}>
                                    <td>{posts.name}</td>
                                    <td>{posts.company}</td>
                                    <td>{posts.email}</td>
                                    <td>{posts.phonenumber}</td>
                                    <td>{posts.media_path_slug}</td>
                                    <td>{posts.leadsource}</td>
                                    <td>{formatDate(posts.dateadded)}</td>
                         
                                    <td>
                                      <select
                                        className="form-control-select is-info show-btn"
                                        onChange={(e, a) =>
                                          changeStatus(e.target.value, posts.id)
                                        }
                                      >
                                        <option>{posts.leadstatus}</option>
                                        {leadstatus.map((el) => (
                                          <option value={el.name}>
                                            {el.name}
                                          </option>
                                        ))}
                                      </select>
                                    </td>
                                    <td>
                                      <button
                                        onClick={() => {
                                          setLaeds(true);
                                          setModel(posts);
                                        }}
                                        className="button is-small is-info show-btn border-0"
                                      >
                                        Edit
                                      </button>
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                          {/* View of pagination */}
                          <Pajination
                            setPostPerPage={setPostPerPage}
                            postPerpage={postPerpage}
                            page={page}
                            setPage={setPage}
                            total={total}
                          />{" "}
                        </>
                      )}
                    </>
                  )}
                </div>
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default WebLeads;
